export default {
	deviceType: 'webApp',
};
